import { addDays, addMonths } from './helpers';

const DAY_MS = 86400000;

export function chooseTickStepsByRange(minDate, maxDate) {
  const totalDays = Math.max(1, Math.round((+maxDate - +minDate) / DAY_MS));
  if (totalDays > 900) return { majorMonths: 6, minorDays: 30 };
  if (totalDays > 240) return { majorMonths: 1, minorDays: 7 };
  if (totalDays > 60) return { majorMonths: 1, minorDays: 3 };
  return { majorMonths: 1, minorDays: 1 };
}

export function buildTimelineTicks(minDate, maxDate) {
  const { majorMonths, minorDays } = chooseTickStepsByRange(minDate, maxDate);
  const major = [];
  const minor = [];

  const startMajor = new Date(minDate);
  startMajor.setDate(1);

  let majorCursor = new Date(startMajor);
  while (majorCursor <= maxDate) {
    major.push(new Date(majorCursor));
    majorCursor = addMonths(majorCursor, majorMonths);
  }

  let minorCursor = new Date(minDate);
  while (minorCursor <= maxDate) {
    minor.push(new Date(minorCursor));
    minorCursor = addDays(minorCursor, minorDays);
  }

  return { major, minor };
}